function sanitizeCsvValue(value) {
  if (typeof value !== 'string') {
    return value
  }
  if (/^[=+\-@"\t\r]/.test(value)) {
    return `'${value}`
  }
  return value
}

export function generateCSV(data, customHeader = null, options = {}) {
  const userInputFields = new Set(options.userInputFields || [])

  let header = []
  if (customHeader) {
    header = customHeader
  } else {
    const headerFromData = Array.from(
      new Set(data.reduce((record, element) => [...record, ...Object.keys(element)], []))
    )
    header = headerFromData
  }

  let csv = data.map((row) =>
    header
      .map((fieldName) => {
        const raw = isNumber(row[fieldName]) ? row[fieldName] : row[fieldName] || ''
        const value = userInputFields.has(fieldName) ? sanitizeCsvValue(raw) : raw
        return JSON.stringify(value)
      })
      .join(',')
  )
  csv.unshift(
    header.map((label) => (userInputFields.has(label) ? sanitizeCsvValue(label) : label)).join(',')
  )
  csv = csv.join('\r\n')

  return csv
}

function isNumber(number) {
  return !isNaN(number) && isFinite(number)
}

export const csvDownload = (data, name, customHeader = null, options = {}) => {
  const filename = name || `export.csv`
  const csv = generateCSV(data, customHeader, options)
  const blob = new Blob([csv], {
    type: 'text/plain;charset=utf-8',
  })

  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(blob, filename)
    return
  }
  const link = document.createElement('a')
  const url = URL.createObjectURL(blob)
  link.href = url
  link.download = filename
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export function downloadCSVDataFromResponseToFile(response, fileName = 'export') {
  const blob = new Blob([response.data], {
    type: response.headers['content-type'],
  })
  const downloadUrl = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = downloadUrl
  a.download = `${fileName}.csv`
  document.body.appendChild(a)
  a.click()
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/libs/csv-download/index.js